import { fg } from '@atlassian/jira-feature-gating';

export function isReactCompilerForLabelsFieldEnabled() {
	if (fg('react_compiler_for_labels_field')) {
		return true;
	}
	return false;
}
